import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'reports/v4';

  pathForType() {
    if (this.modelNamePlural) {
      return this.modelNamePlural;
    }
    return super
      .pathForType(...arguments)
      .replace('reports/', '')
      .toLowerCase();
  }
}
